import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API } from "@/services/API";

const initialState = {
  isOpen: false,
  loadId: null,
  loading: false,
  error: null,
  data: null,
};

export const fetchOpenedLoad = createAsyncThunk("openedLoad/fetch-load", async (loadId, { rejectWithValue }) => {
  try {
    const response = await API.get(`/loads/${loadId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching opened load:", error);
    return rejectWithValue(error.message);
  }
});

const openedLoadSlice = createSlice({
  name: "openedLoad",
  initialState,
  reducers: {
    openLoad: (state, action) => {
      state.isOpen = true;
      state.loadId = action.payload;
    },
    closeLoad: (state) => {
      state.isOpen = false;
      state.loadId = null;
      state.loading = false;
      state.error = null;
      state.data = null;
    },
    resetOpenedLoadState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOpenedLoad.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOpenedLoad.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchOpenedLoad.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Error fetching opened load";
      });
  },
});

export const { openLoad, closeLoad, resetOpenedLoadState } = openedLoadSlice.actions;

export default openedLoadSlice.reducer;
